export const news = [
    {
        title:"As US hiring slumps, tech jobs hold up 'remarkably well'",
        posted:"Posted on June 14, 2021 by admin",
        original:"This article was originally published on ciodive.com"

    },
    {
        title:"The key to unlocking your leadership potential is executive presence",
        posted:"Posted on May 14, 2020 by admin",
        original:"This article was originally published on"
    },
    {
        title:"How IT talent is being found is being transformed by 6 hiring trends",
        posted:"Posted on Feb 11, 2020 by admin",
        original:"This article was originally published on"
    },
    {
        title:"Trends in transformative technologies that will shape our world in 2020 and beyond",
        posted:"Posted on Sep 24, 2019 by admin",
        original:"This article was originally published on"
    }
];